module.exports = __webpack_public_path__ + "static/media/G1-21-Kalya-Linard-cod52.62e07b9e.png";